import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import MasqueradeBanner from "./components/MasqueradeBanner";

function App() {
  return (
    <AuthProvider>
      <MasqueradeBanner />
      <Routes />
    </AuthProvider>
  );
}

export default App;
